import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { IdentityEffects, identityReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([IdentityEffects]), StoreModule.forFeature(`identity`, identityReducer)]
})
export class IdentityStateModule {}
